export default class EventUtil {
  constructor(prefix) {
    this.prefix = prefix
  }

  triggerEvent(name, detail = null, usePrefix = true) {
    let eventName = usePrefix ? this.prefix + name : name
    let event
    if (detail) {
      event = new CustomEvent(eventName, {
        detail: detail,
      })
    }

    if (!detail) {
      event = new CustomEvent(eventName)
    }

    document.dispatchEvent(event)
  }

  addEventListener(name, callback, usePrefix = true) {
    let listenerName = usePrefix ? this.prefix + name : name
    document.addEventListener(listenerName, function (event) {
      callback(event.detail)
    })
  }
}
